import calculatePriceWithDiscount from './calculatePriceWithDiscount';
import { BaseWeeklyPricingAttributes, INDEX } from './types';

/**
 * Retrieve the base CPT or CPM including discount based on a 2D array representation
 * of the 'Weekly Pricing' Google Sheet.
 *
 * @param pricingSheet 2D array representation of the 'Weekly Pricing' sheet
 * @returns Base CPT or CPM price including discount
 */
const getWeekBasePrice = (
  weeklyPricingSheet: Array<Array<any>>,
  attributes: BaseWeeklyPricingAttributes
) => {
  const rowIndex = getRowIndex(weeklyPricingSheet, attributes);
  if (rowIndex === INDEX.NOT_FOUND) return 0;

  const columnIndex = getColumnIndex(weeklyPricingSheet, attributes);
  if (columnIndex === INDEX.NOT_FOUND) return 0;

  return calculatePriceWithDiscount(
    weeklyPricingSheet[rowIndex][columnIndex],
    attributes.discount
  );
};

const getRowIndex = (
  pricingSheet: Array<Array<any>>,
  attribute: BaseWeeklyPricingAttributes
): number => {
  return pricingSheet.findIndex(
    (row: Array<any>) =>
      row[INDEX.DEMOGRAPHIC] === attribute.demographic &&
      row[INDEX.RATECARD] === attribute.ratecard
  );
};

const getColumnIndex = (
  pricingSheet: Array<Array<any>>,
  attribute: BaseWeeklyPricingAttributes
): number => {
  return pricingSheet[INDEX.HEADER_ROW].indexOf(attribute.week);
};

export default getWeekBasePrice;
